import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line no-restricted-imports
import { Container } from 'semantic-ui-react';

// Import components.
import StudentsTable from '../students/components/StudentsTable';

import { useParams } from 'react-router-dom';
import { getTitlePrefix } from '../config/env';
import { PAGE_NAMES, useSegmentPage } from '../segment';

interface RouteParams {
  filter: string;
  [key: string]: string | undefined;
}

const Students = () => {
  const { t } = useTranslation();
  useSegmentPage(PAGE_NAMES.students);

  const { filter } = useParams<RouteParams>();
  const renderPageHead = () => (
    <Helmet>
      <title>
        {getTitlePrefix()}
        {t('pages.students.browserTitle')}
      </title>
      <body className="students" />
    </Helmet>
  );

  return (
    <Container fluid className="no-padding no-margin">
      {renderPageHead()}
      <StudentsTable filter={filter} />
    </Container>
  );
};

export default Students;
